const resetSelect = `
  margin: 0px;
  padding: 0px;
  border: 0px;
  border-radius: 0px;
  background: none;
  box-shadow: none;`;
export const makeSelect = ({ theme, before, variant = 'darken', size = 'medium', menuWidth, maxHeight, optionsOnTop = false, }) => {
    return `${resetSelect}
          font-size: ${theme.form.size[size].fontSize};
          font-weight: 400;
          letter-spacing: 0.009375em;
          box-sizing: border-box;
          width: 100%;
          min-height: ${theme.form.size[size].height};
          transition: opacity 150ms cubic-bezier(0.4, 0, 0.2, 1);
          outline: none;
          position: static!important;

          .select__indicators {
            cursor: pointer;
            
            .select__dropdown-indicator{
              transition: all .2s ease-in-out;
              transform: rotate(0deg);
            }
            
            span {
              display: none;
            }

            .select__indicator {
              padding: 0;
            }
          }

          & > .select__control, 
          & > .select__control:hover {
            ${resetSelect}

            width: 100%;
            color: rgba(0, 0, 24, 0.6);
            padding: ${before ? '0 16px 0 43px' : '0px'};
            min-height: ${theme.form.size[size].height};
            
            
            .select__value-container {
              ${resetSelect}
              
              .select__placeholder {
                ${resetSelect}
              }
              
              [class^="css-"]{
                ${resetSelect}
              }

              .select__single-value{
                margin: 0px;
              }

              .select__input {
                input {
                  font-family: ${theme.fonts.families.base};
                }
              }
            }

            &.select__control--menu-is-open {
              ${resetSelect}

              .select__indicators {
                .select__dropdown-indicator{
                  transform: rotate(180deg);
                }
              }
            }

            &.select__control--menu-is-focused {
              ${resetSelect}
            }
          }

          & > .select__menu {
            min-width: ${menuWidth || `100%`};
            margin-top: 4px;
            border-radius: 8px;
            background:  ${variant === 'lighten' ? '#ffffff' : `${theme.colors.grey4}`}
            z-index: 11;
            padding: 8px;
            left: 0;
            right: 0;
            ${optionsOnTop ? 'top: -5px;Transform: translateY(-100%);' : ''}
            border: 1px solid ${theme.colors.grey24};

            .select__placeholder, 
            .select__value-container .select__single-value {
            }

            .select__menu-list {
              padding: 0px;
              ${maxHeight ? `height: ${maxHeight};` : ''}
              
              .select__option {
                border-radius: 4px;
                font-weight: 600;
                padding: 8px 12px;
                line-height: 20px;
                font-size: ${theme.form.size[size].fontSize};
                cursor: pointer;
  
                &.select__option--is-selected, 
                &.select__option--is-focused {
                  color: ${theme.form.variant[variant].idle.color};
                  background: ${variant === 'lighten' ? 'rgba(0, 0, 24, 0.04)' : 'rgba(0, 0, 24, 0.08)'};
                }
              }
            }
          }`;
};
export const makeCustomSup = () => {
    return `color: red;`;
};
export const makeAutocomplete = props => {
    return `
    ${makeSelect(props)}
    &  .select__dropdown-indicator {
      display: none;
    }
  `;
};
